import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { KioskCartFunnelFormBlockConfig } from '@front-platform/content-builder';
import { kioskCartFunnelFormBlockResolveConfig } from '@front-platform/content-builder';
import { Observable } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { Component, input } from '@angular/core';
import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
import {
  resolveCartFunnelPadding,
  resolveKioskCartFunnelTopPadding,
} from '../kiosk-cart-funnel-top-padding';

export interface KioskCartFunnelFormBlockRuntimeConfig {
  'block_id'?: string;
  'items'?: unknown[];
}

export type KioskCartFunnelFormBlockConfigInput = Partial<
  Omit<KioskCartFunnelFormBlockConfig, keyof KioskCartFunnelFormBlockRuntimeConfig> &
    KioskCartFunnelFormBlockRuntimeConfig
>;
export type KioskCartFunnelFormBlockResolvedConfig = Omit<
  KioskCartFunnelFormBlockConfig,
  keyof KioskCartFunnelFormBlockRuntimeConfig
> &
  Partial<KioskCartFunnelFormBlockRuntimeConfig>;
export interface KioskCartFunnelFormBlockContract extends ConfigComponentContract<
  KioskCartFunnelFormBlockConfigInput,
  KioskCartFunnelFormBlockResolvedConfig
> {}

@Component({
  selector: 'app-kiosk-cart-funnel-form-block',
  templateUrl: './kiosk-cart-funnel-form-block.component.html',
  standalone: false,
})
export class KioskCartFunnelFormBlockComponent implements KioskCartFunnelFormBlockContract {
  readonly config = input<KioskCartFunnelFormBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    KioskCartFunnelFormBlockConfig,
    KioskCartFunnelFormBlockRuntimeConfig
  >(kioskCartFunnelFormBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get topPadding(): string {
    return resolveKioskCartFunnelTopPadding(this.resolvedConfig().top_padding);
  }
  get bottomPadding(): string {
    return resolveCartFunnelPadding(this.resolvedConfig().bottom_padding);
  }
  get fillHeight(): boolean {
    return this.resolvedConfig().fill_height !== false;
  }
  get blockId(): string {
    return this.resolvedConfig()['block_id'] as unknown as string;
  }
  get items(): unknown[] {
    return this.resolvedConfig()['items'] as unknown as unknown[];
  }

  isActive$: Observable<boolean> = this.cartFunnelSelector.selectActiveStepId.pipe(
    map(id => id === this.blockId),
    delay(0), // Delay to ensure the value is updated after the change detection cycle, I don't know why here it was not updated correctly
  );

  constructor(private cartFunnelSelector: CartFunnelStoreSelector) {}
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(KioskCartFunnelFormBlockComponent, {
  'keyAliases': {},
});
